import React, { useState } from 'react';

interface FilesManagement {
  files: File[];
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
  onAttachFile: (fileList: FileList | null) => void;
  onEditFile: (fileToEdit: File, fileName: string) => void;
  onDeleteFile: (fileToRemove: File) => void;
}

export const useFilesManagement = (): FilesManagement => {
  const [files, setFiles] = useState<File[]>([]);

  const onAttachFile = (fileList: FileList | null) => {
    if (fileList) {
      setFiles((prevState) => [...prevState, ...Array.from(fileList)]);
    }
  };

  const onDeleteFile = (fileToRemove: File) => {
    setFiles((prevState) =>
      prevState.filter((file: File) => file !== fileToRemove)
    );
  };

  const onEditFile = (fileToEdit: File, fileName: string) => {
    const file = files.find((file: File) => file === fileToEdit);
    if (file) {
      const newFile = new File([file], fileName, {
        type: file.type
      });
      setFiles((prevState) =>
        prevState.map((fileMap) => (fileMap === fileToEdit ? newFile : fileMap))
      );
    }
  };

  return {
    files,
    setFiles,
    onAttachFile,
    onEditFile,
    onDeleteFile
  };
};
